import React from "react";
import { BadgeCtn } from "./Badge.style";

export type BadgeColor = "crimson" | "success" | "pending" | "danger";

export type BadgeProps = {
  children: React.ReactNode;
  $color?: BadgeColor;
};

export const Badge = ({ children, $color }: BadgeProps) => {
  return <BadgeCtn $color={$color}>{children}</BadgeCtn>;
};
